import { Role } from '../enums/role.enum';
import { AdminUser } from './admin-user';
import { CompanyUser } from './company-user';
import { PhysicianUser } from './physician-user';

export interface CurrentUser {
  email: string;

  fullName: string;

  role: Role;

  defaultUrl: string;
}

export function createUser(user: any): CompanyUser | AdminUser | PhysicianUser {
  switch (user.role) {
    case Role.COMPANY_ADMIN:
    case Role.MSL:
    case Role.SALES_REP:
    case Role.PATIENT_ASSISTANCE:
    case Role.ADMIN && user.companyId != null:
      return new CompanyUser(user);
    case Role.ADMIN:
      return new AdminUser(user);
    case Role.DOCTOR:
      return new PhysicianUser(user);
    default:
      return null;
  }
}
